import React, { Component } from 'react'
import bildFlo from '../images/flo_vorstellung'
import bildDiana from '../images/diana_vorstellung'
import signatureFlorian from '../images/standalone/originals/signatureFlo.svg'

class PersonPresenter extends Component {
    constructor(props) {
        super(props);
        this.loadedImages = 0;
        this.totalImages = 2;
    }

    onImgLoaded(id) {
        this.loadedImages++;
        if (this.loadedImages >= this.totalImages) {
            this.props.onImgLoaded('PersonPresenter');
            this.loadedImages = 0;
        }
    }

    render() {
        return (
            <div className="PersonPresenter-container" >
                <div className="PersonPresenter-text1">
                    <h2>Über Flo</h2>
                    <div className="PersonPresenter-subsection">
                        <div className="PersonPresenter-subsection-col1">Gitarre</div>
                        <div className="PersonPresenter-subsection-col3">–</div>
                        <div className="PersonPresenter-subsection-col2">Gesang</div>
                        <div className="PersonPresenter-subsection-col3">–</div>
                        <div className="PersonPresenter-subsection-col2">Cajon</div>
                        {/* <div className="PersonPresenter-subsection-col3">–</div>
                        <div className="PersonPresenter-subsection-col2">Mundharmonika</div> */}
                    </div>
                    <p>
                        Florian gilt als leidenschaftlicher Gitarrist seit über 15 Jahren.<br/>
                        Schon immer interessiert er sich sehr für Musik und spielte daher bereits in mehreren Bands verschiedenster Genres.
                        Eine Spanne von Schlager über Pop bis hin zu Rock zeigt seine Vielseitigkeit.<br />
                    </p>

                    <div className="PersonPresenter-cite">
                        &bdquo;Einfach Spaß an der Musik&ldquo;
                    </div>

                    <p>
                        Zu Florian’s Stärken zählen vor allem seine individuell einzigartigen und auch klassischen Solos.
                        Viel Rhythmusgefühl und seine musikalischen Stärken zeigt Florian an den verschiedensten Gitarren, mit fetzigen Beats an der Cajon und Solos an der Mundharmonika. <br/>
                        Seine Überzeugung ist der Spaß an der Musik, der auf das Publikum überspringt, ganz egal an welchem Instrument Florian sitzt.
                    </p>
                    <p className="PresentationPresenter-signatureFlorian">
                        <img src={signatureFlorian} alt="signatureFlo"/>
                    </p>
                </div>
                <img className="PersonPresenter-img PersonPresenter-img1" src={bildFlo[this.props.imgResIndex]} alt="Bild Flo" onLoad={() => this.onImgLoaded("bildFlo")} />

                <div className="PersonPresenter-text2">
                    <h2>Über Diana</h2>
                    <div className="PersonPresenter-subsection">
                        <div className="PersonPresenter-subsection-col1">Gesang</div>
                        <div className="PersonPresenter-subsection-col3">–</div>
                        <div className="PersonPresenter-subsection-col2">Gitarre</div>
                        <div className="PersonPresenter-subsection-col3">–</div>
                        <div className="PersonPresenter-subsection-col2">Cajon</div>
                    </div>
                    <p>
                        Die stets engagierte Musikerin steht seit ihrem 13. Lebensjahr auf der Bühne.
                        Vor allem durch ihre musikalische Begleitung bei Hochzeiten und Taufen hat sie sich bereits einen Namen gemacht. <br/>

                        Sie stellte sich im Jahr 2015 bei Florian als Gitarrenschülerin vor.
                        Ihre Vorstellungen von Musik passten gut zusammen und nach einigen öffentlichen
                        Auftritten gründeten sie dann im Frühjahr 2017 die Coverband.
                    </p>

                    <div className="PersonPresenter-cite">
                        &bdquo;Laut und leise - alles dabei&ldquo;
                    </div>
                    <p>

                        Diana’s Talent? Sie macht jedes Lied zu ihrem eigenen.
                        Egal ob Rocksongs von Bon Jovi oder Balladen von Ed Sheeran. Jedes Lied ist einzigartig.<br/>
                        Ihre Intensionen: gute Laune – Abwechslung – Individualität<br/>

                        Mehr von Diana als Solistin für Hochzeiten und Taufen findet ihr unter <a href="http://www.diana-sonntag.de">www.diana-sonntag.de</a>.
                    </p>
                    <p className="PresentationPresenter-signatureDiana" style={{fontSize: "33px"}}>
                        Diana
                    </p>
                </div>
                <img className="PersonPresenter-img PersonPresenter-img2" src={bildDiana[this.props.imgResIndex]} alt="Bild Diana" onLoad={() => this.onImgLoaded("bildDiana")} />
            </div >
        );
    }
}

export default PersonPresenter;



// WEBPACK FOOTER //
// ./src/mainpage-body/personpresenter.js